import { XCircleIcon } from "@heroicons/react/24/solid";
import "./styles/modal.sass";
interface IProps {
    isOpen: boolean;
    closeModalFn: () => void;
    children: React.ReactNode;
    actions?: React.ReactNode;
}
/**
 * A simple modal component that will display whatever is given to it as a child
 * @param {boolean}   isOpen	   -  Is the modal open?
 * @param {function}  closeModalFn -  The function to execute to close the modal when the X icon is clicked
 */
const Modal = ({ isOpen, closeModalFn, children, actions }: IProps) => {
    return (
        <div
            className={`modal ${isOpen ? "modal--open" : ""}`}
            aria-hidden={!isOpen}
        >
            <div
                className={`modal__overlay ${isOpen ? "modal__overlay--open" : ""
                    }`}
                onClick={closeModalFn}
            ></div>
            <div
                className={`modal__dialog ${isOpen ? "modal__dialog--open" : ""
                    }`}
                data-testid="modal"
            >
                <button
                    aria-label="Close modal"
                    role="dialog"
                    onClick={closeModalFn}
                    className="modal__dialog__closebtn"
                    type="button"
                >
                    <span>Close</span>
                    <XCircleIcon className="icon" />
                </button>
                {children}
                <div className="modal__dialog__actions">{actions}</div>
            </div>
        </div>
    );
};
export default Modal;
